const MuiCard = {
  styleOverrides: {
    root: {
      borderRadius: 8,
    },
  },
};

export default MuiCard;
